import { useState, useEffect, useRef, useCallback } from "react";
import PropTypes from "prop-types";
import styles from "./add-to-calendar.module.less";
import UiBkgImage from "@rnb/ui-bkg-image";
import SiteConfigurationStore from "components/stores/site-configuration-store";
import { EventAggregator, PrimaryButton, ScheduleStore } from "@parksandresorts/core";

const AddToCalendar = (props) => {
  const aRef = useRef();
  const [icalText, setIcalText] = useState(null);
  const [events, setEvents] = useState([]);

  const storeEvents = useCallback(async () => {
    const ics = await import("ics");

    const { error, value } = ics.createEvents(
      events
        .map((event) => {
          return event.events.map((occasion) => {
            const startDate = occasion.startDateAndTime;
            const endDate = occasion.endDateAndTime;
            const preamble = event.preamble ? event.preamble.preamble : null;
            const start = [
              startDate.getUTCFullYear(),
              startDate.getUTCMonth() + 1,
              startDate.getUTCDate(),
              startDate.getUTCHours(),
              startDate.getUTCMinutes(),
            ];
            const end = endDate
              ? [
                  endDate.getUTCFullYear(),
                  endDate.getUTCMonth() + 1,
                  endDate.getUTCDate(),
                  endDate.getUTCHours(),
                  endDate.getUTCMinutes(),
                ]
              : null;
            const calendarText = event.calendarText ? event.calendarText.calendarText : null;
            const calendarLink = event.calendarLink ? event.calendarLink : null;

            return {
              title: event.title,
              description: calendarText ? calendarText : preamble,
              startInputType: "utc",
              endInputType: "utc",
              start: start,
              end: end ?? undefined,
              duration: end ? undefined : { hours: 3 },
              location: "Gröna Lund - " + event.location,
              url: calendarLink ? calendarLink : window.location.href,
              alarms: [{ action: "display", trigger: { hours: 48, before: true } }],
            };
          });
        })
        .flat(),
    );

    if (!error) {
      setIcalText(value);

      EventAggregator.publish("trackEvent", {
        category: "Add to Calendar",
        action: "Clicked button",
        label: "Add concert",
      });
    }
  }, [events]);

  useEffect(() => {
    if (icalText) {
      aRef.current.click();
    }
  }, [icalText]);

  useEffect(() => {
    async function fetchEvents() {
      try {
        const events = await ScheduleStore.getEventsForShowIds(props.showIds);
        setEvents(events);
      } catch (e) {}
    }
    fetchEvents();
  }, [props.showIds]);

  return (
    <div className={[styles.wrapper]}>
      <div className={styles.innerWrapper}>
        <div className={[styles.imageWrapper]}>
          <UiBkgImage imageUrlForLargeDevice={props.image} imageUrlForSmallDevice={props.image} />
        </div>
        <div className={[styles.textWrapper]}>
          <h2 className={styles.header}>{SiteConfigurationStore.getLabel("ADD_TO_CALENDAR")}</h2>
          <p>{SiteConfigurationStore.getLabel("ADD_TO_CALENDAR_TEXT")}</p>
          <PrimaryButton
            complementary
            label={SiteConfigurationStore.getLabel("ADD_TO_CALENDAR_BUTTON")}
            iconLeftNew="calendar"
            onClick={storeEvents}
            className={[styles.addBtn, "waves-effect"].join(" ")}
          />
          <a
            className={styles.hidden}
            ref={aRef}
            href={"data:text/calendar;charset=utf8," + encodeURIComponent(icalText || null)}
            download="Grönan Live - Konserter"
          >
            Grönan Live - Konserter
          </a>
        </div>
      </div>
    </div>
  );
};

AddToCalendar.propTypes = {
  showIds: PropTypes.array.isRequired,
  image: PropTypes.string.isRequired,
};

export default AddToCalendar;
